import { Injectable } from '@angular/core';
import { ServiceBase } from '../../../../shared/service-base/ServiceBase';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class TipoInsucessoService extends ServiceBase {

  private baseUrlService: string;

  constructor(http: HttpClient, router: Router) {
    super(http, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/cruzamento_tipo_insucesso`;
  }

  public getTipoInsucessos(): Promise<any> {
    return this.get([]);
  }

  public adicionarTipoInsucessos(nome: string): Promise<any> {
    const url = this.getURL();
    const body = { descInsucessoFab: nome };
    const options = (this as any).getOptions();

    return (this as any).http.post(url, body, options).toPromise().then((this as any).tratarRetorno);
  }

  public removerTipoInsucessos(id: number): Promise<any> {
    const url = `${this.getURL()}?idTipoInsucesso=${id}`;
    const options = (this as any).getOptions();

    return (this as any).http.delete(url, options).toPromise().then((this as any).tratarRetorno);
  }

  public atualizarTipoInsucessos(id: number, nome: string): Promise<any> {
    const parametros = [{ nome: 'idTipoInsucesso', valor: id.toString() }];
    const body = { descInsucessoFab: nome };

    return this.atualizar(body, parametros);
  }

  public getTipoInsucessosPorId(id: number): Promise<any> {
    const parametros = [
      { nome: 'idTipoInsucesso', valor: id.toString() }
    ];
    return this.get(parametros);
  }

  public getVinculosTipoInsucessos(idTipoInsucesso: number): Promise<any> {
    const url = `${this.getURL()}/vinculos?idTipoInsucesso=${idTipoInsucesso}`;
    const options = (this as any).getOptions();

    return (this as any).http.get(url, options).toPromise().then((response: any) => {
      return (this as any).tratarRetorno(response);
    })
      .catch((error: any) => {
        console.error('Erro na requisição de vínculos:', error);
        throw error;
      });
  }

  public salvarVinculosTipoInsucessos(idTipoInsucessos: number, elementosVinculados: any[]): Promise<any> {
    const url = `${this.getURL()}/vincular?idTipoInsucesso=${idTipoInsucessos}`;
    const body = {
      descTipoInsucesso: elementosVinculados.map(elemento => ({
        descTipoInsucesso: elemento.nome
      }))
    };
    const options = (this as any).getOptions();

    return (this as any).http.post(url, body, options).toPromise().then((response: any) => {
      return (this as any).tratarRetorno(response);
    })
      .catch((error: any) => {
        console.error('Erro ao salvar vínculos:', error);
        throw error;
      });
  }
}
